import type { ColumnConfig } from '@/components/configure-columns-dialog';

// Default column configuration for the Tasks screen
export const DEFAULT_TASKS_COLUMNS: ColumnConfig[] = [
  // Default columns (visible by default)
  { id: 'title', label: 'Title', visible: true, order: 0, group: 'default' },
  { id: 'type', label: 'Type', visible: true, order: 1, group: 'default' },
  { id: 'priority', label: 'Priority', visible: true, order: 2, group: 'default' },
  { id: 'status', label: 'Status', visible: true, order: 3, group: 'default' },
  { id: 'assignee', label: 'Assignee', visible: true, order: 4, group: 'default' },
  { id: 'dueDate', label: 'Due Date', visible: true, order: 5, group: 'default' },
  { id: 'links', label: 'Links', visible: true, order: 6, group: 'default' },
  { id: 'progress', label: 'Progress', visible: true, order: 7, group: 'default' },
];

export const TASKS_COLUMNS_STORAGE_KEY = 'tasks-columns-config';
